import React from 'react';
import { Spinner } from '../../components/ui';
import CrudFormModal from '../../components/CrudFormModal';

// Desktop Functions UI — a table. Add/Edit/Del are Owner/Event-Admin only.
export default function FunctionsDesktop({ vm }) {
  const { filtered, loading, columns, can, q, setQ, startAdd, startEdit, del } = vm;
  const showActions = can.edit || can.delete;
  return (
    <div>
      <div className="page-head">
        <h1>Functions</h1>
        <span className="muted">{filtered.length}</span>
        <div className="spacer" />
        <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 200 }} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Function</button>}
      </div>

      <div className="card table-wrap">
        {loading ? <Spinner /> : filtered.length === 0 ? (
          <div className="empty">No functions yet.{!can.add && ' Ask the Event Owner to add functions.'}</div>
        ) : (
          <table className="tbl">
            <thead>
              <tr>
                {columns.map(c => <th key={c.key}>{c.label}</th>)}
                {showActions && <th></th>}
              </tr>
            </thead>
            <tbody>
              {filtered.map(row => (
                <tr key={row.FunctionId} className="row-link" title="Open guests of this function" onClick={() => vm.openRow(row)}>
                  {columns.map(c => <td key={c.key}>{c.render ? c.render(row) : (row[c.key] ?? '—')}</td>)}
                  {showActions && (
                    <td style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                      {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                      {can.delete && <button className="btn danger sm" style={{ marginLeft: 6 }} onClick={() => del(row)}>Del</button>}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <CrudFormModal vm={vm} title="Function" />
    </div>
  );
}
